import React, { useContext, useEffect, useState } from 'react';
import {
  ArrowBackRounded,
  CloseRounded,
  FilterListRounded,
  SearchRounded,
} from '@mui/icons-material';
import {
  Box,
  Button,
  Container,
  Drawer,
  IconButton,
  Skeleton,
  TextField,
} from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import InfiniteScroll from 'react-infinite-scroll-component';
import moment from 'moment';
import Images from '../../../../Configs/images';
import ROUTES from '../../../../Configs/routes';
import AlertContext from '../../../../Context/AlertContext';
import Elements from '../../../Elements';
import { getCart, getSaleItem } from '../../../../Redux/Models/market';
import { getUserData } from '../../../../Utils/storages';
import { formatNumToCurrency } from '../../../../Utils/helpers';
import Colors from '../../../../Configs/colors';

const types = [
  {
    label: 'Fixed Price',
    value: 'Fixed Price',
  },
  {
    label: 'Auction',
    value: 'Auction',
  },
];

const sorts = [
  {
    label: 'Newest',
    value: 'asc',
  },
  {
    label: 'Oldest',
    value: 'desc',
  },
];

const sortsPrice = [
  {
    label: 'Lower price',
    value: 'Lowest',
  },
  {
    label: 'Higher price',
    value: 'Highest',
  },
];

export default function SaleItem({
  classes, error, message, sales, totalPage, isLoading, currentPage, cart,
}) {
  const userData = getUserData();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = getUserData();
  const [page, setPage] = useState(1);
  const [param, setParam] = useSearchParams();
  const keyword = param.get('keyword') || '';
  const type = param.get('type') || '';
  const sort = param.get('sort') || '';
  const sortprice = param.get('sortprice') || '';
  const category = param.get('category') || '';

  const allFilter = {
    type, sort, sortprice, category,
  };

  const [items, setItems] = useState([]);
  const [openFilter, setOpenFilter] = useState(false);

  const { openAlert } = useContext(AlertContext);

  const toggleOpenFilter = () => {
    setOpenFilter(!openFilter);
  };

  const getData = () => {
    dispatch(getSaleItem(user.id, {
      page, keyword, saleType: type, sort, sortprice, category,
    }));
  };

  const handleApplyFilter = async () => {
    await setItems([]);
    await setPage(1);
    getData();
    setOpenFilter(false);
  };

  const handleResetFilter = async () => {
    await setParam({ });
    await setItems([]);
    getData();
  };

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (keyword) {
        setItems([]);
        setPage(1);
      }
      getData();
    }, 1500);

    return () => clearTimeout(delayDebounceFn);
  }, [keyword]);

  useEffect(() => {
    if (currentPage > 1) {
      setItems([...items, ...sales]);
    } else if (currentPage === 1) {
      setItems(sales);
    }
  }, [currentPage]);

  const loadMore = () => {
    setPage((p) => p + 1);
  };

  useEffect(() => {
    if (!keyword) {
      getData();
    }
  }, [page]);

  useEffect(() => {
    if (error) {
      openAlert({
        message: `Something went wrong. ${message}`,
        severity: 'error',
      });
    }
  }, [error]);

  useEffect(() => {
    dispatch(getCart(userData.id));
  }, []);

  return (
    <Elements.PageBase noNav navigate={navigate}>
      <div className={classes.root}>
        <Box
          display="flex"
          className="sticky"
          justifyContent="space-between"
          alignItems="center"
          gap={1.5}
          py={1}
          px={2}
          border="1px solid #E5E5E5"
          borderTop="none"
          bgcolor="white"
        >
          <IconButton sx={{ p: 0 }} onClick={() => navigate(ROUTES.market())}>
            <ArrowBackRounded sx={{ color: '#2E3C40' }} />
          </IconButton>
          <TextField
            value={keyword}
            onChange={({ target }) => setParam({ ...allFilter, keyword: target.value })}
            InputProps={{
              startAdornment: (<SearchRounded className="mute" sx={{ mr: 1 }} fontSize="small" />),
            }}
            fullWidth
            placeholder="Search by name or keyword"
            size="small"
          />
          {
            cart && cart.length > 0 ? (
              <Box position="relative">
                <IconButton sx={{ p: 0 }} onClick={() => navigate(ROUTES.cart())}>
                  <img src={Images.MarketBlack} height="20" width="20" alt="cart" />
                </IconButton>
                <Box
                  className="s-6 weight-700 white flex flex-center align-items-center"
                  borderRadius="50%"
                  bgcolor="#004C3B"
                  width="10px"
                  height="10px"
                  position="absolute"
                  top="0"
                  right="0"
                >
                  {cart.length}
                </Box>
              </Box>
            )
              : (
                <IconButton
                  disabled={!userData.subscription}
                  sx={{ p: 0 }}
                  onClick={() => navigate(ROUTES.cart())}
                >
                  <img src={Images.MarketBlack} height="20" width="20" alt="cart" />
                </IconButton>
              )
          }
        </Box>
        <Container>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mt={1}
          >
            <Box className="s-12 weight-600">
              {items.length}
              {' '}
              {items.length > 1 ? 'results' : 'result'}
            </Box>
            <Button
              startIcon={<FilterListRounded />}
              onClick={toggleOpenFilter}
              sx={{
                color: 'black',
                px: 1,
                py: 0.25,
                textTransform: 'none',
                border: '1px solid #E5E5E5',
                borderRadius: 2,
                fontFamily: 'Nunito Sans',
              }}
            >
              Filter
            </Button>
          </Box>

          <Box mt={2}>
            <InfiniteScroll
              next={loadMore}
              hasMore={Boolean(totalPage > currentPage)}
              dataLength={items.length}
            >
              {items.map((item, index) => (
                <Box display="flex" gap={1.5} mb={2} onClick={() => navigate(item.id)} key={index}>
                  <img
                    width="80px"
                    height="80px"
                    className="rounded cover"
                    src={item.photo}
                    alt="baco"
                  />
                  <Box flex={1}>
                    <Box className="weight-600">{item.name}</Box>
                    <Box display="flex" className="s-10" color="#586479" gap={0.5} flexWrap="wrap" alignItems="center" mt={0.25}>
                      <div>{item.category_name || '-'}</div>
                      <div>
                        ・
                        {item.condition_name || '-'}
                      </div>
                      <div>
                        ・
                        {item.volume || '0 mL'}
                      </div>
                    </Box>
                    <Box display="flex" justifyContent="space-between" alignItems="center" mt={1}>
                      <Box className="s-16 weight-700">
                        {formatNumToCurrency(Number(item.price))}
                      </Box>
                      <Box display="flex" gap={0.5}>
                        <Box fontSize={12}>Qty 1</Box>
                        <img src={Images.CheckRed} alt="check-icon" />
                      </Box>
                    </Box>
                    {item.sale_type === 'Bid Price'
                    && (
                    <Box className="s-12" mt={0.5}>
                      {item.bidder_count}
                      {' '}
                      bids・
                      {moment(item.end_date).format('DD MMM YYYY (HH.mm)')}
                    </Box>
                    )}
                  </Box>
                </Box>
              ))}
              {isLoading && new Array(5).fill(0).map((item, index) => (
                <Box display="flex" gap={1.5} mb={2} key={index}>
                  <Skeleton
                    variant="rect"
                    width="80px"
                    height="80px"
                    className="rounded"
                    alt="baco"
                  />
                  <Box flex={1}>
                    <Skeleton />
                    <Skeleton sx={{ mt: 1 }} />
                    <Box display="flex" justifyContent="space-between" alignItems="center" mt={1}>
                      <Skeleton width="40px" />
                      <Skeleton width="40px" />
                    </Box>
                    <Skeleton sx={{ mt: 0.5 }} />
                  </Box>
                </Box>
              ))}
              {!isLoading && !items.length && 'There is no data based on your filter'}
            </InfiniteScroll>
          </Box>
        </Container>
      </div>

      <Drawer
        open={openFilter}
        anchor="bottom"
        sx={{ borderRadius: 2 }}
        PaperProps={{ elevation: 0, style: { backgroundColor: '#FDFDFD', borderRadius: '10px 10px 0 0' } }}
        onClose={toggleOpenFilter}
      >
        <Container maxWidth="xs" sx={{ py: 2 }}>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <IconButton sx={{ p: 0 }} onClick={toggleOpenFilter}>
              <CloseRounded sx={{ fontSize: 18, color: '#404852' }} />
            </IconButton>
            <Box fontSize={16} fontWeight="700">Filter</Box>
            <Box className="primary-green link" fontSize={14} onClick={handleResetFilter}>Reset</Box>
          </Box>

          <Box mt={2} mb={1} fontSize={14} fontWeight="600">Sort by</Box>
          <Box display="flex" gap={0.5}>
            {sorts.map((t) => (
              <Box
                fontSize={14}
                bgcolor={sort === t.value ? Colors.primary : 'transparent'}
                color={sort === t.value ? '#fff' : '#404852'}
                key={t.value}
                py="4px"
                px={1}
                borderRadius={2}
                fontWeight="600"
                border="1px solid #E5E5E5"
                className="link"
                onClick={() => setParam({ ...allFilter, sort: t.value })}
              >
                {t.label}
              </Box>
            ))}
            {sortsPrice.map((t) => (
              <Box
                fontSize={14}
                bgcolor={sortprice === t.value ? Colors.primary : 'transparent'}
                color={sortprice === t.value ? '#fff' : '#404852'}
                key={t.value}
                py="4px"
                px={1}
                borderRadius={2}
                fontWeight="600"
                border="1px solid #E5E5E5"
                className="link"
                onClick={() => setParam({ ...allFilter, sortprice: t.value })}
              >
                {t.label}
              </Box>
            ))}
          </Box>
          <Box mt={2} mb={1} fontSize={14} fontWeight="600">Sale type</Box>
          <Box display="flex" gap={0.5}>
            {types.map((t) => (
              <Box
                fontSize={14}
                bgcolor={type === t.value ? Colors.primary : 'transparent'}
                color={type === t.value ? '#fff' : '#404852'}
                key={t.value}
                py="4px"
                px={1}
                borderRadius={2}
                fontWeight="600"
                border="1px solid #E5E5E5"
                className="link"
                onClick={() => setParam({ ...allFilter, type: t.value })}
              >
                {t.label}
              </Box>
            ))}
          </Box>

          <Button
            fullWidth
            className="btn-contained"
            variant="contained"
            sx={{ mt: 2 }}
            onClick={handleApplyFilter}
          >
            Apply Filter
          </Button>
        </Container>
      </Drawer>
    </Elements.PageBase>
  );
}
